module.exports = __webpack_public_path__ + "img/background-errors.a20c4db9.jpg";